const endPoint = process.env.REACT_APP_backend || "http://localhost:1555";
console.log(process.env.REACT_APP_backend);

export async function getLanguages() {
    const response = await fetch(endPoint + "/languages" );
    return response.json();
}